module.exports = __webpack_public_path__ + "static/media/img-openscout-reference@3x.0bc2dff1.png";